import { Controller } from "@hotwired/stimulus"
import {translate as t, human_attribute_name} from 'common/i18n'
import select2 from 'select2'
const $ = select2()

function formatOption(data) {
  if(!data?.id) return data.text || '';
  let province = '';
  if(data.province) province = ` (${data.province})`
  let tpl = `<div><b>${data.name}</b>${province}</div>`
  if(data.code) tpl += `<div>Codice FIPSAS: ${data.code}</div>`
  return $(tpl)
}

function formatSelection(data) {
  if(!data?.id) return data.text || '';
  let province = '';
  if(data.province) province = ` (${data.province})`
  let code = '';
  if(data.code) code = `${data.code} `
  let tpl = `<div>${code}<b>${data.name}</b>${province}</div>`
  return $(tpl)
}

export default class extends Controller {
  static targets = [
    'dialog',
    'form',
    'searchPanel',
    'resultsPanel',
    'results',
    'loadMore',
    'message',

    'teamId',
    'name',
    'lastName',
    'badgeCode',

    'badgeCodes'
  ]
  static values = {
    team: Object,
    actionUrl: String,
    searchUrl: String,
    teamsUrl: String,
  }

  connect() {
    this.createDialog()
    this.endLoad()
  }

  disconnect() {
    $(this.element.querySelector('[data-reveal]')).foundation('_destroy');
  }

  async submit(ev) {
    if(!this.selectTarget.value) {
      ev.preventDefault()
      return;
    }
    this.beginLoad()
  }

  createDialog() {
    let csrfParam = document.querySelector('meta[name="csrf-param"]')?.content
    let csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    let teamsSelector = '';
    if(this.hasTeamValue) {
      teamsSelector = `<input type="hidden" value="${this.teamValue.code}" name="person[team_code]" data-people--import-target="teamId"></select>`
    } else {
      teamsSelector = `
        <div class="grid-x grid-margin-x">
          <div class="cell">
            <label>${human_attribute_name('Person', 'team')}
              <select name="person[team_code]" data-people--import-target="teamId"></select>
            </label>
          </div>
        </div>
      `
    }

    this.element.innerHTML = `
      <div class="reveal" data-people--import-target="dialog" data-reveal>
        <h4>${t('admin.people.index.api_import')}</h4>
        <button class="close-button" aria-label="Close modal" type="button" data-close>
          <span aria-hidden="true">&times;</span>
        </button>
        <p class="message">${t('admin.people.index.api_import_help')}</p>
        <form action="${this.actionUrlValue}" method="post" data-people--import-target="form">
          <input type="hidden" name="${csrfParam}" value="${csrfToken}">

          <div class="search" data-people--import-target="searchPanel">
            <div class="grid-x grid-margin-x">
              <div class="cell small-6">
                <label>${human_attribute_name('Person', 'name')}
                  <input type="text" name="person[name]" data-people--import-target="name"
                    data-action="keydown.enter->people--import#search:prevent">
                </label>
              </div>
              <div class="cell small-6">
                <label>${human_attribute_name('Person', 'last_name')}
                  <input type="text" name="person[last_name]" data-people--import-target="lastName"
                    data-action="keydown.enter->people--import#search:prevent">
                </label>
              </div>
            </div>
            <div class="grid-x grid-margin-x">
              <div class="cell">
                <label>${human_attribute_name('Person', 'badge_code')}
                  <input type="text" name="person[badge_code]" data-people--import-target="badgeCode"
                    data-action="keydown.enter->people--import#search:prevent">
                </label>
              </div>
            </div>
            ${teamsSelector}
            <div class="message" data-people--import-target="message"></div>
            <div class="text-right">
              <button class="button secondary hollow" type="button" data-close>${t('cancel')}</button>
              <button class="button button primary search-button" type="button"
                data-action="people--import#search:prevent">${t('search')}</button>
            </div>
          </div>

          <div class="results hide" data-people--import-target="resultsPanel">
            <button type="button" class="button secondary hollow back"
              data-action="people--import#back:prevent">
              <i class="fas fa-arrow-left"></i> ${t('search')}
            </button>
            <button type="button" class="button secondary clear select-all float-right"
              data-action="people--import#selectAll:prevent">
              ${t('select_all')} <i class="far fa-check-square"></i>
            </button>
            <div class="items">
              <table class="table">
                <tbody data-people--import-target="results"></tbody>
              </table>
            </div>
            <div class="text-right">
              <button class="button secondary hollow" type="button" data-close>${t('cancel')}</button>
              <button class="button button primary" type="submit"
                data-people--import-target="submitButton">${t('admin.people.index.import')}</button>
            </div>
          </div>
        </form>
      </div>
    `

    let reveal = $(this.element.querySelector('[data-reveal]'))
    new Foundation.Reveal(reveal, {appendTo: this.element})
    reveal.foundation('open')

    if(this.teamIdTarget?.tagName == 'SELECT') {
      $(this.teamIdTarget).select2({
        templateResult: formatOption,
        templateSelection: formatSelection,
        allowClear: true,
        placeholder: {text: '', name: ''},
        ajax: {
          url: this.teamsUrlValue,
          dataType: 'json',
          processResults: (data)=> {
            let results = data.teams
            let pagination = {}
            pagination.more = data.pagination.pages > data.pagination.page
            results.forEach((x)=> x.id = x.code)
            return { results, pagination }
          }
        }
      })
    }
  }

  async search({params: { page }}) {
    let query = {}
    let valid = false

    if(this.nameTarget.value) {
      query.name = this.nameTarget.value
      valid = true
    }
    if(this.lastNameTarget.value) {
      query.last_name = this.lastNameTarget.value
      valid = true
    }
    if(this.badgeCodeTarget.value) {
      query.badge_code = this.badgeCodeTarget.value
      valid = true
    }
    if(this.teamIdTarget.value) {
      query.team_code = this.teamIdTarget.value
      valid = true
    }

    if(valid) {
      this.beginLoad()
      query.scope = 'team_connected'
      query.page = page ? page : 1
      query.limit = 100

      const url = new URL(this.searchUrlValue, window.location.origin)
      url.search = new URLSearchParams(query).toString()
      const params = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
      }
      let response = await fetch(url, params)
      let data = await response.json()

      this.messageTarget.childNodes.forEach((ch)=> ch.remove())

      if(data?.people?.length > 0) {
        if(!page) {
          this.resultsTarget.childNodes.forEach((ch)=> ch.remove())
        } else if(this.hasLoadMoreTarget) {
          this.loadMoreTarget.remove()
        }

        data?.people?.forEach((p)=> {
          let tr = document.createElement('tr')
          tr.innerHTML = this.renderPerson(p)
          this.resultsTarget.appendChild(tr);
        });

        if(data.pagination.pages > data.pagination.page) {
          let tr = document.createElement('tr')
          tr.innerHTML = `<td class="text-center" colspan="2" data-people--import-target="loadMore" >
            <button type="button" class="button small secondary hollow"
              data-action="people--import#search:prevent"
              data-people--import-page-param="${parseInt(data.pagination.page)+1}"
              >${t('load_more')}</button>
          </td>`
          this.resultsTarget.appendChild(tr);
        }

        this.searchPanelTarget.classList.add('hide')
        this.resultsPanelTarget.classList.remove('hide')
      } else {
        this.messageTarget.innerHTML = `
          <div class="callout alert-callout-border alert">
            ${t('no_results_found')}
          </div>
        `
        this.searchPanelTarget.classList.remove('hide')
        this.resultsPanelTarget.classList.add('hide')
      }

      this.endLoad()
    }
  }

  selectAll() {
    let checked = this.badgeCodesTargets[0].checked
    this.badgeCodesTargets.forEach((c)=> c.checked = !checked)
  }

  back() {
    this.searchPanelTarget.classList.remove('hide')
    this.resultsPanelTarget.classList.add('hide')
    this.resultsTarget.childNodes.forEach((ch)=> ch.remove())
  }

  beginLoad() {
    if(!this._mask) {
      this._mask = document.createElement('div')
      this._mask.classList.add('loading-mask')
      this._mask.innerHTML = '<i class="fas fa-spinner fa-3x fa-spin"></i>'
      this.dialogTarget.appendChild(this._mask)
    }
  }

  endLoad() {
    if(this._mask) {
      this._mask.remove()
      this._mask = null
    }
  }

  renderPerson(person) {
    let badges = person.athlete_badges || []
    let badge_code = person.badge_code || badges[0]?.code
    let team_name  = person.team_name || badges.map((b)=> b.team_name).join(', ')
    return `
      <td>
        <b>${person.last_name} ${person.name}</b><br>
        ${human_attribute_name('person', 'badge_code')}: ${badge_code || '-'}<br>
        ${human_attribute_name('person', 'team')}: ${team_name || '-'}
      </td>
      <td class="text-right">
        <input type="checkbox" name="person[badge_codes][]"
          data-people--import-target="badgeCodes"
          value="${badge_code}" >
      </td>
    `
  }
}
